<template>
  <DialogLayout
    title="詳細情報"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
  >
    <template #form>
      <FeesForStopForm
        ref="feesForStopForm"
        v-model="feesForStopFormModel"
        label-width="10em"
        formMode="edit"
        billingYmMode="search"
        :editDisabledMode="editDisabledMode"
        :autocomplete-customer-code-set="autocompleteCustomerCodeSet"
        :autocomplete-registration_symbol-set="autocompleteRegistrationSymbolSet"
        :autocomplete-airport-code-set="autocompleteAirportCodeSet"
        :autocomplete-model-code-set="autocompleteModelCodeSet"
      />
    </template>
    <template v-if='!editDisabledMode' #footer>
      <EditDialogFooter
        @update="clickUpdate"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import FeesForStopForm from '@/components/organisms/dialog/calculation/FeesForStopForm.vue'
import EditDialogFooter from '@/components/organisms/dialog/EditDialogFooter.vue'
// import FeesForStopAutocompleteLoader from '@/mixins/FeesForStopAutocompleteLoader.vue'

export default {
  components: {
    DialogLayout,
    FeesForStopForm,
    EditDialogFooter
  },
  props: {
    autocompleteRegistrationSymbolSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteModelCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    currentRow: {
      type: Object,
      default: () => {
        return {}
      }
    },
    visible: Boolean
  },
  data () {
    return {
      feesForStopFormModel: {
        registration_symbol: undefined,
        action_time: undefined,
        action_type: undefined,
        billing_ym: undefined,
        bill_to_code: undefined,
        route_code: undefined,
        callsign: undefined,
        departure_airport_code: undefined,
        destination_airport_code: undefined,
        model_code: undefined,
        stop_fee_without_tax: undefined,
        stop_fee_tax: undefined,
        stop_fee_with_tax: undefined,
        tax: undefined,
        taxation: undefined,
        flight_purpose_code: undefined,
        aircraft_type: undefined,
        weight: undefined,
        stops: undefined,
        stop_minutes: undefined,
        unit_fee: undefined,
        regist_type: undefined,
        billing_exclusion_flag: undefined,
        updated_on: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    },
    editDisabledMode: {
      get () {
        return this.feesForStopFormModel.regist_type === '1' || parseInt(this.feesForStopFormModel.billing_ym) < parseInt(this.getDefaultBillingYm())
      }
    }
  },
  mounted () {
  },
  methods: {
    async clickUpdate () {
      this.$loadingMask.on()
      this.$refs.feesForStopForm.validate()
        .then((valid) => {
          return this.$axios.put('/fees-for-stop', this.feesForStopFormModel)
        })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.dialogVisible = false
          this.$emit('refresh', this.feesForStopFormModel.billing_ym)
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
          this.$loadingMask.off()
        })
    },
    open () {
      const trimItem = ['registration_symbol', 'bill_to_code', 'action_type']
      this.$nextTick(() => {
        this.$refs.feesForStopForm.clearFields()
        Object.keys(this.feesForStopFormModel)
          .forEach((x) => {
            if (trimItem.includes(x)) {
              this.currentRow[x] = this.currentRow[x].trimEnd()
            }
            this.$set(this.feesForStopFormModel, x, this.currentRow[x])
          })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
